import Grid from "@mui/material/Grid";
import {IconButton, InputAdornment, Select, TextField} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import PlaceIcon from "@mui/icons-material/Place";
import MenuItem from "@mui/material/MenuItem";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import Paper from "@mui/material/Paper";
import React, {useState} from "react";
import "./SearchBar.css"
import {getCategoryByValue, getJobTypeByValue} from "./JobCard";

const style = {
    "& label.Mui-focused": { color: "#000000" },
    "& .MuiOutlinedInput-root": { "&.Mui-focused fieldset": { borderColor: "#000000" } },
};

const SearchBar = ({onSearch, regions, categories, types, filterTypes, filterCategories, filterRegions}) => {
    const [isFocusedRegion, setIsFocusedRegion] = useState(false);
    const [isFocusedCategory, setIsFocusedCategory] = useState(false);
    const [isFocusedType, setIsFocusedType] = useState(false);
    const [region, setRegion] = useState("");
    const [category, setCategory] = useState("");
    const [type, setType] = useState("");

    const handleChange = (e) => {
        const {value} = e.target;
        onSearch(value)
    }

    const filterType = (e) => {
        const {value} = e.target;
        setType(value)
        filterTypes(value)
        setIsFocusedType(true)
    }

    const filterCategory = (e) => {
        const {value} = e.target;
        setCategory(value)
        filterCategories(value)
        setIsFocusedCategory(true)
    }

    const filterRegion = (e) => {
        const {value} = e.target;
        setRegion(value)
        filterRegions(value)
        setIsFocusedRegion(true);
    }


    const handleBlurRegion = () => {
        // Only hide the label if no value is selected
        if (!region) {
            setIsFocusedRegion(false);
        }
    };

    const handleBlurCategory = () => {
        // Only hide the label if no value is selected
        if (!category) {
            setIsFocusedCategory(false);
        }
    };

    const handleBlurType = () => {
        // Only hide the label if no value is selected
        if (!type) {
            setIsFocusedType(false);
        }
    };

    const handleFocusRegion = () => setIsFocusedRegion(true);
    const handleFocusCategory = () => setIsFocusedCategory(true);
    const handleFocusType = () => setIsFocusedType(true);

    return (
        <Paper data-testid={"search-bar"} style={{backgroundColor: '#000000', borderRadius: "20px", padding:'20px'}}>
            <Grid container direction={"row"} justifyContent={"center"} alignItems={"center"}>
                <Grid item xs={12}>
                    <h2 className={"searchTitle"}>Search</h2>
                </Grid>

                <Grid item xs={12}>
                    <TextField className={"searchField"} data-testid={"text-search"}
                               onChange={(e) => {
                                   handleChange(e)
                               }}
                               placeholder={"Search..."}
                               sx={{
                                   style,
                                   "& fieldset": { border: 'none' },
                               }}
                               InputProps={{
                                   endAdornment: <InputAdornment position="end" style={{height: '100%'}}>
                                       <IconButton size={"large"} sx={{backgroundColor: "#FF6600"}}>
                                           <SearchIcon style={{ backgroundColor: '#FF6600',
                                               color: 'white',
                                               borderRadius: '12px',
                                           }}
                                           />
                                       </IconButton>
                                   </InputAdornment>,
                               }}
                    />
                </Grid>

                <Grid container direction={"row"} paddingTop={2} spacing={2}>
                    <Grid item hidden={!regions}>
                        <FormControl sx={style} size="small">
                            {!isFocusedRegion && <InputLabel><PlaceIcon className={"select-icon"}/>Region</InputLabel>}
                            <Select className={"dropdown-select"}
                                sx={{
                                    "& fieldset": { border: 'none' },
                                    minWidth: "140px",
                                }}
                                    autoWidth
                                style={{backgroundColor: 'white'}}
                                    onFocus={handleFocusRegion}
                                    onBlur={handleBlurRegion}
                                onChange={(e) => {filterRegion(e)}}
                            >
                                <MenuItem value="all">
                                    All
                                </MenuItem>
                                {regions?.map((city, index) => (
                                    <MenuItem value={city} key={index}>
                                        {(city)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item hidden={!categories}>
                        <FormControl fullWidth sx={style} size="small">
                            {!isFocusedCategory && <InputLabel><BusinessCenterIcon className={"select-icon"}/>Job Category</InputLabel>}
                            {/*<InputLabel><BusinessCenterIcon className={"select-icon"}/>Job Category</InputLabel>*/}
                            <Select
                                sx={{
                                    minWidth: "170px",
                                    "& fieldset": { border: 'none' },
                                }}
                                autoWidth
                                className={"dropdown-select"}
                                style={{backgroundColor: 'white'}}
                                label={"Job Category"}
                                onFocus={handleFocusCategory}
                                onBlur={handleBlurCategory}
                                onChange={(e) => {filterCategory(e)}}
                            >
                                <MenuItem value="all">
                                    All
                                </MenuItem>
                                {categories?.map((category, index) => (
                                    <MenuItem value={category} key={index}>
                                        {getCategoryByValue(category)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item hidden={!types}>
                        <FormControl fullWidth sx={style} size="small">
                            {!isFocusedType && <InputLabel><TravelExploreIcon className={"select-icon"}/>Opportunity type</InputLabel>}
                            <Select
                                sx={{
                                    minWidth: "200px",
                                    "& fieldset": { border: 'none' },
                                }}
                                autoWidth
                                className={"dropdown-select"}
                                style={{backgroundColor: 'white'}}
                                label="Region"
                                onFocus={handleFocusType}
                                onBlur={handleBlurType}
                                onChange={(e) => {filterType(e)}}
                            >
                                <MenuItem value="all">
                                    All
                                </MenuItem>
                                {types?.map((type, index) => (
                                    <MenuItem value={type} key={index}>
                                        {getJobTypeByValue(type)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>

            </Grid>
        </Paper>
    )
}

export default SearchBar;